import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; 
import API_URL from './api/config';
import ReactModal from 'react-modal';

function RegisterConfirm() {

    const navigate = useNavigate();

    const hasRedirected = useRef(false);
      
      const [loading, setLoading] = useState(false);

    axios.defaults.withCredentials = true;

const userEmail = localStorage.getItem('email');


useEffect(() => {
  if (!userEmail) return;

  const interval = setInterval(() => {
    axios.post(`${API_URL}/registration-check-email-verified-api`, {
      email: userEmail
    })
    .then(res => {

      if (
        res.data.Status === "Success" &&
        res.data.Verified === true &&
        !hasRedirected.current
      ) {
        hasRedirected.current = true;

        toast.success("Email verified successfully!", {
          position: "top-right",
          autoClose: 2000
        });

        setTimeout(() => {
          navigate('/home');
        }, 2000);
      }

    })
    .catch(err => {
      console.error("Verification check error:", err);
    });

  }, 2000);

  return () => clearInterval(interval);
}, [userEmail, navigate]);




    const handleResendEmail = (e) => {
      e.preventDefault();
      setLoading(true);  
  
      axios.post(`${API_URL}/registration-resend-email-api`, {
        email: userEmail
      })
        .then(res => {
          if (res.data.Status === "Success") {
            toast.success("Check your email", { position: "top-right", autoClose: 3000 });
          } else {
            toast.error(res.data.Message, { position: "top-right", autoClose: 3000 });
          }
        })
        .catch(() => {
          toast.error("An error occurred. Please try again.", { position: "top-right", autoClose: 3000 });
        })
        .finally(() => {
          setLoading(false);
        });
    };


    return (
          
      <div className="bg_med_green text-white d-flex align-items-center justify-content-center" style={{ 
        background: 'linear-gradient(135deg, #f4f7f5 0%, #e8f0ea 100%)',
        fontFamily: "'DM Sans', sans-serif",
        padding: '1rem',
        minHeight: '100vh'
      }}>
        <ToastContainer />
        <div className="container" style={{ 
          maxWidth: '520px', 
          padding: '0',
          margin: 'auto'
        }}>
          <div className="row justify-content-center">
            <div className="col-12">
              <div className="bg-med-green text-white p-0 rounded" style={{
                background: '#ffffff',
                borderRadius: '24px',
                overflow: 'hidden',
                boxShadow: '0 20px 40px -12px rgba(0, 0, 0, 0.25)',
                animation: 'fadeInUp 0.5s ease-out'
              }}>
                
                {/* Header - With Icon */}
                <div style={{
                  background: 'linear-gradient(135deg, #0d6e28 0%, #0a5520 100%)',
                  padding: '1.5rem 1.5rem 1rem 1.5rem',
                  textAlign: 'center',
                  position: 'relative'
                }}>
                  {/* Professional Icon - Animated Envelope with Checkmark */}

                  
                  <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    marginBottom: '0.75rem'
                  }}>

<div style={{
  width: '60px',
  height: '60px',
  background: 'rgba(255,255,255,0.15)',
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  animation: 'float 3s ease-in-out infinite'
}}>
  <i className="fas fa-paper-plane" style={{ fontSize: '28px', color: 'white', transform: 'rotate(15deg)' }}></i>
</div>

                     
                  </div>
                  
                  <h3 style={{
                    color: 'white',
                    margin: '0.5rem 0 0.25rem',
                    fontSize: '1.3rem',
                    fontWeight: '600'
                  }}>
                    Confirm Your Email
                  </h3>
                  <p style={{
                    color: 'rgba(255,255,255,0.9)',
                    fontSize: '0.75rem',
                    marginBottom: 0
                  }}>
                    We've sent a verification link to your email
                  </p>
                </div>
      
                {/* Body - Compact and fits without scrolling */}
                <div style={{ padding: '1.25rem' }}>
                  <form onSubmit={handleResendEmail}>
                    
                    {/* Email Display */}
                    <div style={{
                      background: '#f8fcf9',
                      borderRadius: '12px',
                      padding: '0.75rem',
                      marginBottom: '1rem',
                      border: '1px solid #e5ede8',
                      textAlign: 'center'
                    }}>
                      <p style={{
                        margin: 0,
                        color: '#666',
                        fontSize: '0.7rem',
                        marginBottom: '0.25rem'
                      }}>
                        Verification email sent to
                      </p>
                      <p style={{
                        margin: 0,
                        color: '#0d6e28',
                        fontSize: '0.85rem',
                        fontWeight: '600',
                        wordBreak: 'break-all'
                      }}>
                        {userEmail || 'your@email.com'}
                      </p>
                    </div>
                    
                    {/* Info Message */}
                    <div style={{
                      background: '#fef3e8',
                      borderLeft: '3px solid #ff6600',
                      borderRadius: '8px',
                      padding: '0.75rem',
                      marginBottom: '1rem'
                    }}>
                      <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                        <span style={{ fontSize: '1rem' }}>📬</span>
                        <p style={{ 
                          margin: 0, 
                          color: '#5a3a1a', 
                          fontSize: '0.8rem', 
                          fontWeight: '500'
                        }}>
                          Please check your email and click the verification link
                        </p>
                      </div>
                    </div>
      
                    {/* Resend Button */}
                    <button
                      type="submit" className='btn-primary'
                      disabled={loading}
                      style={{
                        width: '100%',
                        background: loading ? '#c0cfc5' : '#ff6600',
                        border: 'none',
                        borderRadius: '40px',
                        padding: '0.7rem',
                        fontWeight: '600',
                        fontSize: '0.85rem',
                        cursor: loading ? 'not-allowed' : 'pointer',
                        color: '#ffffff',
                        marginBottom: '0.75rem',
                        transition: 'all 0.2s ease'
                      }}
                      onMouseEnter={(e) => {
                        if (!loading) e.target.style.background = '#e55a00';
                      }}
                      onMouseLeave={(e) => {
                        if (!loading) e.target.style.background = '#ff6600';
                      }}
                    >
                      {loading ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2" role="status" style={{ width: '0.8rem', height: '0.8rem' }}></span>
                          Sending...
                        </>
                      ) : (
                        <>
                          <i className="fas fa-paper-plane me-2"></i>
                          Resend Verification Email
                        </>
                      )}
                    </button>
      
                    {/* Login Button */}
                    <button
                      type="button"
                      onClick={() => navigate('/')}
                      style={{
                        width: '100%',
                        padding: '0.7rem',
                        backgroundColor: 'transparent',
                        color: '#0d6e28',
                        border: '1.5px solid #0d6e28',
                        borderRadius: '40px',
                        fontSize: '0.85rem',
                        fontWeight: '600',
                        cursor: 'pointer',
                        marginBottom: '0.75rem',
                        transition: 'all 0.2s ease'
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.backgroundColor = '#0d6e28';
                        e.target.style.color = 'white';
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.backgroundColor = 'transparent';
                        e.target.style.color = '#0d6e28';
                      }}
                    >
                      <i className="fas fa-sign-in-alt me-2"></i>
                      Back to Login
                    </button>
      
                    {/* Note */}
                    <div style={{
                      background: '#f8fcf9',
                      borderRadius: '8px',
                      padding: '0.5rem',
                      textAlign: 'center'
                    }}>
                      <p style={{
                        fontSize: '0.6rem',
                        color: '#999',
                        margin: 0
                      }}>
                        <i className="fas fa-envelope" style={{ marginRight: '6px' }}></i> 
                        Didn't receive the verification link? Check your spam folder.
                      </p>
                    </div>
                  </form>
                </div>
      
                {/* Footer - Minimal */}
                <div style={{
                  borderTop: '1px solid #e5ede8',
                  padding: '0.6rem',
                  background: '#fafdfb',
                  textAlign: 'center'
                }}>
                  <p style={{
                    fontSize: '0.6rem',
                    color: '#8aa899',
                    margin: 0
                  }}>
                    <i className="fas fa-headset me-1"></i>
                    Need help? Contact support@oret.africa
                  </p>
                </div>
      
              </div>
            </div>
          </div>
        </div>
      
        {/* CSS Animation */}
        <style>
          {`
            @keyframes fadeInUp {
              from {
                opacity: 0;
                transform: translateY(20px);
              }
              to {
                opacity: 1;
                transform: translateY(0);
              }
            }
            
            @keyframes pulse {
              0%, 100% {
                transform: scale(1);
              }
              50% {
                transform: scale(1.05);
              }
            }
              @keyframes float {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-5px); }
}
          `}
        </style>
      </div>
    );
}

export default RegisterConfirm;
